const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "교육훈련평가 결과서"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "시나리오명",
        key: "body.시나리오명",
      },
      {
        name: "관리부서",
        key: "body.관리부서",
      },
      {
        name: "교육훈련평가 결과",
        key: "body.평가결과",
        style: { minWidth: "150px" },
      },
      {
        name: "교육훈련평가 결과서",
        key: "body.결과서",
        style: { minWidth: "150px" },
      },
      {
        name: "교육훈련일",
        key: "body.교육훈련일",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).시나리오명; // 시나리오명
        case 3:
          return func.getContent(value).관리부서; // 관리부서
        case 4:
          return func.getContent(value).평가결과; // 교육훈련평가 결과
        case 5: {
          // 교육훈련평가 결과서
          const file = func.getContent(value).결과서;
          return {
            type: "docs",
            file: file,
          };
        }
        case 6:
          return func.getContent(value).교육훈련일; // 교육훈련일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
